const H = {
  name: "KualaLumpur",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 0V4H15V8H17.7208L19.0797 12.0767L15.6181 19H15V24H13V19H11V24H9V19H8.38205L4.92041 12.0767L6.27932 8H9V4H11V0H13ZM11 8H13V6H11V8ZM7.72084 10L7.38751 11H16.6127L16.2793 10H7.72084ZM8.11811 14H15.882L16.382 13H7.61811L8.11811 14ZM9.11811 16L9.61811 17H14.382L14.882 16H9.11811Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as KualaLumpur
};
